<template>
<Window :id="'newSpecial'" :title="isEdit?getLanguageStr('word1952','编辑特殊规则'):getLanguageStr('word1961','添加新特殊规则')" ref="Window" @Closed="$emit('Close')">
	<div slot="headButton" class="fR cb tra-fast_E ml05x_E">
		<button class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
		<button class="functionBtn" type="button" @click="add"  :class="{disable:!form.alertId}">{{$t('cmd84',['保存'])}}</button>
	</div>
	<div fillHeight="window,-#newSpecial .head" scroll>
		  <div class="w60pct mc mt2x mb2x">
		  	 <ul class="w44pct_E dpIB_E mt2x_E vaT_E">
		  	 	<li class="w100pct">
		  	 		<div class="cSub mb1x"><span class="cWarning">*</span>{{getLanguageStr('word27','报警')}}:</div>
		  	 		<NewAlarm  @Update="updateAlarm" :initData="initData" v-if="newAlarmShow" :disabled="isEdit?true:false"></NewAlarm>
		  	 	</li>
		  	 	<li class="w100pct">
		  	 		<div class="cSub mb1x">{{getLanguageStr('phrase968','是否接收及接收渠道')}}
		  	 		<OnOff v-model="switch1" class="ml05x"/></div>
		  	 		<div  v-if="switch1">
		  	 			<div class="mr2x dpIB" v-if="channel.hasChannelOfEmail"><Checkbox v-model="form.emailChannel" :text="getLanguageStr('word1945','邮件')"></Checkbox></div>
						<div class="mr2x dpIB" v-if="channel.hasChannelOfSms"><Checkbox v-model="form.smsChannel" :text="getLanguageStr('word1946','短信')"></Checkbox></div>
					 	<div class="mr2x dpIB" v-if="channel.hasChannelOfVoice"><Checkbox v-model="form.voiceChannel" :text="getLanguageStr('word1947','电话语音')"></Checkbox></div>
						<div class="mr2x dpIB" v-if="channel.hasChannelOfPush"><Checkbox v-model="form.pushChannel" :text="getLanguageStr('word1940','APP推送')"></Checkbox></div>
		  	 		</div>
               	</li>
               	<li class="w100pct" v-if="switch1">
					<div class="w45pct fL mr2x">
						<div class="cSub mb1x"><span class="cWarning">*</span>{{getLanguageStr('word1943','连续几次触发后发送')}}:<Help :code="'successiveTriggers'" :btnClose="false" class="ml05x"></Help></div>
							<InputText :maxLength="2"
								only="absInt"
								:verification="'notEmpty,~:1~50'"
								v-model="form.seriesNum"
								:placeholder="getLanguageStr('message5','正整数，1～50之间')"
								ref="seriesNum"
								/>
					</div>
					<div class="w45pct fL">
						<div class="cSub mb1x"><span class="cWarning">*</span>{{getLanguageStr('message3','每日推送上限')}}:<Help :code="'dailyPushLimit'" :btnClose="false" class="ml05x"></Help></div>
						<InputText :maxLength="2"
							only="absInt"
							:verification="'notEmpty,~:1~50'"
							v-model="form.dailyLimitNum"
							:placeholder="getLanguageStr('message5','正整数，1～50之间')"
							ref="dailyLimitNum"
							/>
					</div>
		  	 	</li>
               	<li class="w100pct" v-if="switch1">
                <div class="cSub mb1x"><span class="cWarning">*</span>{{getLanguageStr('word1944','接收人')}}:</div>
					<related-person title="" @Update="updatePersonList" ref="SearchPerson" :maxNum='50'  v-if="editPersonShow" :initPersonData="initPersonData" :allRomveFlag="false"></related-person>
               	</li>
		  	 </ul>
		  </div>
	</div>
</Window>
</template>
<script>
import * as lib from '@/util/lib'
import Checkbox from '@/components/common/ui/Checkbox.vue'
import Select from '@/components/common/ui/Select.vue'
import Window from '@/components/common/ui/WindowForNew.vue'
import OnOff from '@/components/common/ui/OnOff.vue'
import RelatedPerson from '@/view/maintain/light/plant/part/RelatedPerson'
import NewAlarm from '@/view/manage/message/NewAlarm'
import InputText from '@/components/common/ui/InputText'
import {insertSpecial,updataSpecial,getChannelConfig} from '@/api/manage/message.js'
import Help from '@/components/common/Help.vue'
export default {
	name: 'newSpecial',
	components: {Checkbox,Window,Select,OnOff,RelatedPerson,NewAlarm,InputText,Help},
	data () {
		return {// 待提交的数据
			promptModeList:(function(){
				let y = lib.getTypeText('', 'promptMode', true)
				        return y
				}()),
			frequencyList:(function(){
			 	 let y = lib.getTypeText('', 'frequency', true)
			     let obj = [{ id: [0], name: getLanguageStr('word806','请选择'),value:0,token:true}]
			     return obj.concat(y)
			}()),
			switch1:true,
			isEdit:false,
			form:{
				seriesNum:3,//加入请选择
				dailyLimitNum:2,
				alertId:null,
				receive:1,
				receiveUserIdList:[],
				emailChannel:false,
				smsChannel:false,
 				voiceChannel:false,
 				pushChannel:true
			 },
			 initData:[],
			 initPersonData:[],
			 newAlarmShow:false,
			 editPersonShow:false,
			 fromWhere:null,
			   channel:{},
			}
		},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		resetData(){
			this.initData=[]
			this.initPersonData=[];
			this.switch1=true;
			this.form={
				seriesNum:3,
				dailyLimitNum:2,
				alertId:null,
				receive:1,
				receiveUserIdList:[],
				emailChannel:false,
				smsChannel:false,
 				voiceChannel:false,
 				pushChannel:true
			 }
			$.each(this.$refs, function () { // 遍历范围内所有需要reset对象,以清除一些报错内容
				if (this && this.reset) this.reset()
			})
		},
			getChannel(){
    			getChannelConfig().then(success => {
	        		this.channel = success
			    }, error => {
			        !_.isEmpty(error) && this.$notify(error)
			    })
    		},
		//来自消息处的设置点击在新增的时候需初始化报警名称
		open(data,initFrom,fromWhere){
			this.getChannel();
			this.fromWhere=fromWhere
			this.newAlarmShow=true
			this.editPersonShow=true
			if(initFrom=="add"){
				statistic('A65','A6501')
				this.resetData();
				if(data){
					this.initData=[{
					'id':data.id,
					'name':data.name
					}]
					this.form.alertId=data.id
				}
				this.isEdit=false;
			}else{
				statistic('A66','A6601')
				this.isEdit=true;
				this.form={...this.form,...data}
				this.initData=[{
					'id':data.alertId,
					'name':data.alertName
				}]
				for(let i=0;i<this.form.receiveUserIdList.length;i++){
					this.initPersonData[i]={
						'id':this.form.receiveUserIdList[i],
						'name':this.form.receiveUserNameList[i]
					}
				}
				if(this.form.emailChannel==1){
					this.form.emailChannel=true
				}else{
					this.form.emailChannel=false
				}
				if(this.form.smsChannel==1){
					this.form.smsChannel=true
				}else{
					this.form.smsChannel=false
				}
				if(this.form.voiceChannel==1){
					
					this.form.voiceChannel=true
				}else{
					this.form.voiceChannel=false
				}
				if(this.form.pushChannel==1){
					this.form.pushChannel=true
				}else{
					this.form.pushChannel=false
				}
			}
			if(this.form.receive==0){
				this.switch1=false
			}else{
				this.switch1=true
			}
			this.$nextTick(() => {
					this.$refs.Window.show()
			});
		},
		Close: function () {
			this.newAlarmShow=false
			this.editPersonShow=false
			this.$refs.Window.hide()
			this.resetData();
			if(!this.isEdit){
				statistic('A65','A6502')
			}else{
				statistic('A66','A6602')
			}
		},
		updateAlarm(data){
			this.$set(this.form,'alertId',data.id)
		},
		add(){
			let data=$.extend(true,{},this.form);
			let allClear = true
			$.each(this.$refs, function () {
				if (this && this.verification) { // 有时候某些组件隐藏掉会导致this为undefined
					let clear = this.doVerification()
					if (allClear) allClear = clear
				}
			})
			if (allClear) {
				if (data.alertId == null) {
				this.$notify(getLanguageStr('plant309', '请选择报警'))
				return false
				}
			if(this.switch1){
					data.receive=1
					if(data.receiveUserIdList.length==0){
						this.$notify(getLanguageStr('plant310', '请选择接收人'))
						return false
					}
					if(data.emailChannel){
						data.emailChannel=1
					}else{
						data.emailChannel=0
					}
					if(data.smsChannel){
						data.smsChannel=1
					}else{
						data.smsChannel=0
					}
					if(data.voiceChannel){
						data.voiceChannel=1
					}else{
						data.voiceChannel=0
					}
					if(data.pushChannel){
						data.pushChannel=1
					}else{
						data.pushChannel=0
					}
				}else{
					data.emailChannel=null;
					data.smsChannel=null;
					data.voiceChannel=null;
					data.pushChannel=null;
					data.receive=0
					data.receiveUserIdList=null
					data.seriesNum=null
					data.dailyLimitNum=null
				}
				if(this.isEdit){
					statistic('A66','A6603')
					updataSpecial(data).then(res=>{
						this.newAlarmShow=false
						this.editPersonShow=false
						this.$refs.Window.hide()
						this.resetData();
						this.$emit('refresh',this.fromWhere);
					},error=>{
						!_.isEmpty(error) && this.$notify(error)
					})
				}else{
					statistic('A65','A6503')
					insertSpecial(data).then(res=>{
						this.$emit('refresh');
						this.newAlarmShow=false
						this.editPersonShow=false
						this.$refs.Window.hide()
						this.resetData();
					},error=>{
						!_.isEmpty(error) && this.$notify(error)
					})
				}
			}else{
				this.$notify(getLanguageStr('phrase538', '请按要求填写表单内容'))
			}
		},
		updatePersonList(data){
			this.form.receiveUserIdList=data
		}
	},
	mounted(){
		 lib.fillHeight()
	}
}
</script>
<style lang="scss" scoped>
.quickNav{
	>*{width:100%;padding:{left:1em;right:1em;top:1em;bottom:1em;};display:block;font-size:1em;
		&:first-child{margin:{top:-.5em;};}
	}
}
*{
	user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/view/manage/message/part/NewSpecial.vue